export const costCategories = {
  validation: { label: "Validation", description: "" },
  monitoring: {
    label: "Monitoring",
    description: "Annual costs for ongoing project monitoring",
  },
  verification: {
    label: "Verification",
    description: "Periodic verification costs",
  },
  issuance: {
    label: "Issuance",
    description: "Costs associated with credit issuance",
  },
  community: {
    label: "Additional community activities",
    description:
      "Optional community engagement, FPIC, safeguards, and other non-payout activities",
  },
};

export const costItems = {
  activity_community_patrols: "Community patrols",
  activity_satellite_monitoring: "Satellite monitoring",
  activity_reforestation_site_prep: "Reforestation site prep",
  activity_reforestation_planting: "Reforestation planting",
  activity_reforestation_nursery: "Reforestation nursery",
  activity_reforestation_maintenance: "Reforestation maintenance",
  activity_firebreak_site_prep: "Firebreak / site prep",
  vvb_validation: "VVB validation",
  vvb_verification: "VVB verification",
  remote_sensing: "Remote sensing",
  mrv_report_prep: "MRV report prep",
  field_ops: "Field operations",
  field_travel: "Field travel",
  plot_establishment: "Plot establishment",
  plot_remeasurement: "Plot remeasurement",
  tree_measurement: "Tree measurement",
  legal_admin: "Legal and admin",
  community_engagement: "Community engagement / FPIC implementation",
  buffer_withholding: "Buffer withholding",
  working_capital_carry: "Working capital carry",
  redd_vvb_validation: "REDD+ VVB validation",
  redd_vvb_verification: "REDD+ VVB verification",
  arr_vvb_validation: "ARR VVB validation",
  arr_vvb_verification: "ARR VVB verification",
  preliminary_ghg_quantification: "Preliminary GHG quantification",
  certification_fee_under_10k_ha: "Certification fee under 10,000 ha",
  certification_fee_10k_to_100k_ha: "Certification fee from 10,000 to 100,000 ha",
  certification_fee_over_100k_ha: "Certification fee over 100,000 ha",
  validation_vvb_fee: "Validation VVB fee",
  mrv_tiered: "MRV fee",
  verification_vvb_fee: "Verification VVB fee",
  project_expansion_fee: "Project expansion fee",
  preliminary_ghg_baseline_assessment: "Preliminary GHG baseline assessment",
  feasibility_assessment: "Feasibility assessment",
  design_review: "Design review",
  plan_vivo_pin_fee: "Plan Vivo PIN fee",
  plan_vivo_pdd_fee_macro: "Plan Vivo PDD fee",
  acceptance_criteria_validation_base: "Acceptance criteria validation base",
  acceptance_criteria_validation_per_property:
    "Acceptance criteria validation per property",
  acceptance_criteria_verification_base: "Acceptance criteria verification base",
  acceptance_criteria_verification_per_property:
    "Acceptance criteria verification per property",
  account_annual: "Annual account fee",
  account_open: "Account opening fee",
  account_registration: "Account registration",
  activation_fee: "Activation fee",
  art_registry_account_annual: "ART registry annual account fee",
  art_trees_issuance_fee: "ART TREES issuance fee",
  baseline_study: "Baseline study",
  baseline_study_core: "Baseline study core",
  benefit_admin: "Benefit administration",
  custodial_annual: "Annual custodial fee",
  data_platform: "Data platform",
  data_processing: "Data processing",
  drone_capex: "Drone equipment",
  drone_depreciation: "Drone depreciation",
  equitable_earth_design_review_base: "Equitable Earth design review base",
  equitable_earth_design_review_per_ha: "Equitable Earth design review per ha",
  equitable_earth_design_review_per_ha_raw:
    "Equitable Earth design review per ha",
  equitable_earth_feasibility_review_base:
    "Equitable Earth feasibility review base",
  equitable_earth_feasibility_review_per_ha:
    "Equitable Earth feasibility review per ha",
  equitable_earth_feasibility_review_per_ha_raw:
    "Equitable Earth feasibility review per ha",
  equitable_earth_monitoring_reporting_base_annual:
    "Equitable Earth annual monitoring and reporting base",
  equitable_earth_monitoring_reporting_per_ha_annual:
    "Equitable Earth annual monitoring and reporting per ha",
  equitable_earth_preliminary_ghg_assessment:
    "Equitable Earth preliminary GHG assessment",
  extension_support: "Extension support",
  farmer_enrollment: "Farmer enrollment",
  fpic_consultation: "FPIC consultation",
  gcc_issuance_fee: "GCC issuance fee",
  gcc_project_registration: "GCC project registration",
  gcc_transaction_registry_account_open:
    "GCC transaction registry account opening",
  gcc_transaction_registry_annual: "GCC transaction registry annual fee",
  insurance: "Insurance",
  inventory_completion: "Inventory completion",
  inventory_completion_core: "Inventory completion core",
  inventory_core: "Inventory core",
  issuance_fee_sop_cash: "SOP cash issuance fee",
  lca_modeling: "LCA modeling",
  leakage_analysis: "Leakage analysis",
  listing_review: "Listing review",
  metering_pack: "Metering package",
  monitoring_drone: "Monitoring drone",
  nursery_opex: "Nursery operations",
  output_audit: "Output audit",
  pada_fee: "PADA fee",
  pada_linear: "PADA per-hectare fee",
  parcel_mapping: "Parcel mapping",
  per_credit_monitoring: "Per-credit monitoring",
  performance_review: "Performance review",
  pipeline_listing: "Pipeline listing",
  planting: "Planting",
  pooling_fee: "Pooling fee",
  preliminary_review: "Preliminary review",
  registration_review: "Registration review",
  registry_annual: "Annual registry fee",
  requantification_transition: "Requantification transition",
  retirement_fee: "Retirement fee",
  royalty_fee: "Royalty fee",
  sampling: "Sampling",
  sensor_calibration: "Sensor calibration",
  sensor_capex: "Sensor equipment",
  sensor_depreciation: "Sensor depreciation",
  sensor_package: "Sensor package",
  share_of_proceeds: "Share of proceeds",
  site_maintenance: "Site maintenance",
  site_prep: "Site preparation",
  social_carbon_issuance_fee: "SOCIALCARBON issuance fee",
  social_carbon_project_design_review: "SOCIALCARBON project design review",
  social_carbon_registration_review: "SOCIALCARBON registration review",
  stock_change_review: "Stock-change review",
  survival_sampling: "Survival sampling",
  validation_review: "Validation review",
  vcu_issuance_levy: "VCU issuance levy",
  verification_fee_base: "Verification fee base",
  verification_fee_per_site: "Verification fee per site",
  verification_review: "Verification review",
};

export const costItemNotes = {
  redd_vvb_validation:
    "Estimate uses sourced market bands [V3][V4]; final amount requires a VVB quote.",
  redd_vvb_verification:
    "Estimate uses sourced market bands [V3][V4]; final amount requires a VVB quote.",
  arr_vvb_validation:
    "Estimate uses sourced market bands [V3][V4]; final amount requires a VVB quote.",
  arr_vvb_verification:
    "Estimate uses sourced market bands [V3][V4]; final amount requires a VVB quote.",
  preliminary_ghg_quantification:
    "Paid after receiving the preliminary GHG potential quantification.",
  certification_fee_under_10k_ha: "Projects under 10,000 ha.",
  certification_fee_10k_to_100k_ha: "Projects from 10,000 ha to 100,000 ha.",
  certification_fee_over_100k_ha: "Projects over 100,000 ha.",
  validation_vvb_fee:
    "Paid by Equitable Earth and re-billed to the developer at contract signature.",
  mrv_tiered: "Paid every year at the beginning of the year.",
  verification_vvb_fee: "Re-billed at each verification audit.",
  project_expansion_fee: "Per expansion outside the adaptive management period.",
  preliminary_ghg_baseline_assessment: "Group 2 sequence.",
  feasibility_assessment: "Group 2 sequence.",
  design_review: "Group 2 sequence.",
};
